/**
 * Get active subscription status for giving email
 * @param {object} state - The vuex state object
 * @return {Boolean} Get active subscription status for giving email
 */
export const userHaveActiveSubscription = (state) => state.activeSubscription;
